// Drop-in replacement for `sonner`'s `toast` API used across the codebase.
// Calls are routed through a centered acknowledgement modal so the user must
// click OK to dismiss every error/success/warning/info message.

import { pushNotification } from "@/lib/notify-store";

function makeToast(type) {
  return (message, opts = {}) => {
    pushNotification({ type, message, description: opts?.description || "" });
  };
}

const toast = (message, opts = {}) =>
  pushNotification({ type: "info", message, description: opts?.description || "" });

toast.success = makeToast("success");
toast.error = makeToast("error");
toast.warning = makeToast("warning");
toast.info = makeToast("info");
toast.message = (message, opts = {}) =>
  pushNotification({ type: "info", message, description: opts?.description || "" });
toast.dismiss = () => {}; // no-op; the modal owns its own lifecycle

export { toast };
export default toast;
